module.exports = {
  postal: {
    key: 'postal',
    label: 'Postal',
  },
  physical: {
    key: 'physical',
    label: 'Physical',
  },
  both: {
    key: 'both',
    label: 'Both',
  },
};